export default "https://assets-v2.scaler.com/packs/images/Img_1000.493439.svg";